module.exports = __webpack_public_path__ + "assets/img/18_177.fc202c4d.jpg";